import classes from '@/components/Shares/Tab.module.css';
import { tokens } from '@/config/tokens';
import { useWithdraw } from '@/providers/WithdrawProvider';
import { i18n } from '@lingui/core';
import { Box, Card, Flex, Grid, Tabs } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { OtherTabItem } from '../OtherTabItem';
import { TokenTabItem } from '../TokenTabItem';
import { WithdrawPayCard } from './WithdrawPayCard';
import { WithdrawTransaction } from './WithdrawTransaction';
export const Withdraw: React.FC = () => {
  const {
    activeTab,
    setActiveTab
  } = useWithdraw();
  const isMobile = useMediaQuery('(max-width: 62em)');
  return <Tabs.Panel value="withdraw">
      {activeTab !== 'crypto' ? <Tabs value={activeTab} variant="pills" allowTabDeactivation classNames={classes}>
          <Tabs.List>
            <Card w="100%" radius={5} bg="var(--bg-600)" p={{
          base: 10,
          sm: 20
        }}>
              <Flex direction={{
            base: 'column',
            md: 'row'
          }} gap={{
            base: 10,
            sm: 12,
            md: 20
          }}>
                <Grid gutter={{
              base: 10,
              sm: 20
            }}>
                  {tokens.map(item => <Grid.Col key={item.name} span={2}>
                      <Tabs.Tab w="100%" miw={{
                  base: 'auto',
                  lg: 100
                }} h={{
                  base: 67,
                  sm: 44
                }} px={10} value={item.symbol} onClick={() => setActiveTab(item.symbol)}>
                        <TokenTabItem tokenImage={item.logoURI} tokenName={item.symbol} />
                      </Tabs.Tab>
                    </Grid.Col>)}
                </Grid>

                <Tabs.Tab value="other" w={117} bg={isMobile ? 'transparent' : ''} ml="auto" onClick={() => setActiveTab('other')}>
                  <OtherTabItem />
                </Tabs.Tab>
              </Flex>
            </Card>
          </Tabs.List>

          {tokens.map(item => <Tabs.Panel key={`panel-${item.symbol}`} value={item.symbol}>
              <WithdrawTransaction />
            </Tabs.Panel>)}
          <Tabs.Panel value="other">{i18n._('Other')}</Tabs.Panel>
        </Tabs> : <Box>
          <WithdrawPayCard />
        </Box>}
    </Tabs.Panel>;
};